import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer 
      className="text-gray-800"
      style={{
        background: 'linear-gradient(135deg, #F8F9FA 0%, #E9ECEF 100%)'
      }}
    >
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/80ff5c93b4a3019548b68e429c50a7d0.png"
                alt="Logo"
                className="h-24 w-auto"
              />
            </div>
            <div className="flex gap-4 mt-2">
              <a
                href="https://x.com/mdr_invest?s=21"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-lg flex items-center justify-center w-5 h-5 text-gray-700"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/madr-investment"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg flex items-center justify-center w-5 h-5 text-gray-700"></i>
              </a>
            </div>
          </div>

          {/* الشركة */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-gray-900">الشركة</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  عن مدار
                </Link>
              </li>
              <li>
                <Link to="/company-profile" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  منظومه مدار&nbsp;
                </Link>
              </li>
              <li>
                <Link to="/board-members" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  أعضاء مجلس الإدارة
                </Link>
              </li>
              <li>
                <Link to="/chairman-word" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  كلمة رئيس مجلس الإدارة
                </Link>
              </li>
              <li>
                <Link to="/ceo-word" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  الإدارة التنفيذية
                </Link>
              </li>
            </ul>
          </div>

          {/* الخدمات */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-gray-900">الخدمات</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/projects" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  المشاريع
                </Link>
              </li>
              <li>
                <Link to="/partners" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  عملاؤنا
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  تواصل معنا
                </Link>
              </li>
            </ul>
          </div>

          {/* استثماراتنا */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-gray-900">
              <Link to="/projects" className="hover:text-gray-700 transition-colors cursor-pointer">
                استثماراتنا ومشاريعنا
              </Link>
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/projects/makkah" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  مشاريع مكة المكرمة
                </Link>
              </li>
              <li>
                <Link to="/projects/madinah" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  مشاريع المدينة المنورة
                </Link>
              </li>
              <li>
                <Link to="/projects/riyadh" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  مشاريع الرياض
                </Link>
              </li>
              <li>
                <Link to="/projects/jeddah" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  مشاريع جدة
                </Link>
              </li>
              <li>
                <Link to="/projects/taif" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  مشاريع الطائف
                </Link>
              </li>
              <li>
                <Link to="/projects/abha" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  مشاريع أبها
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="py-6 border-t border-gray-200" style={{ backgroundColor: '#0F4C5C' }}>
        <div className="container mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/90">
            جميع الحقوق محفوظة لشركة مدار للاستثمار © 2025
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
          >
            Powered by AAIT
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
